/**
 * Configuration de routing i18n — SOT consommée par le middleware next-intl et
 * par `navigation.ts`.
 *
 * `localePrefix: 'always'` : chaque page porte sa locale (`/fr/...`, `/en/...`),
 * une URL = une langue. Un path nu (`/`, `/dmcs/foo`) est redirigé en 307 vers la
 * locale négociée — cookie, puis `Accept-Language`, puis `defaultLocale`.
 *
 * `'as-needed'` a été écarté : vérifié dans `middleware.js`, il redirige quand
 * même dès que la locale négociée diffère du défaut, donc l'URL non préfixée
 * n'est pas déterministe — on garderait le problème d'indexation qu'on cherche
 * précisément à supprimer.
 *
 * Deux réglages non-défauts, tous deux volontaires :
 *   - `localeCookie.maxAge` : le défaut next-intl est un cookie de SESSION.
 *     L'omettre transformerait la persistance 1 an actuelle en « oublié à la
 *     fermeture du navigateur ».
 *   - `alternateLinks: false` : le header `Link:` généré par next-intl pointe un
 *     `x-default` vers le pathname non préfixé, qui sera une 307 sous `'always'`.
 *     On émet les `hreflang` en metadata (`localizedAlternates`), un seul
 *     émetteur, testable.
 */

import { defineRouting } from 'next-intl/routing';

import { defaultLocale, locales } from './config';

const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365;

export const routing = defineRouting({
    locales,
    defaultLocale,
    localePrefix: 'always',
    localeDetection: true,
    localeCookie: { maxAge: ONE_YEAR_IN_SECONDS },
    alternateLinks: false,
});
